import Axios from 'axios';
import { Config } from '../apiRoutes';
import mime from 'mime';

import {
  THRESHOLDS_INDEX_REQUESTED,
  THRESHOLDS_INDEX_SUCCESS,
  THRESHOLDS_INDEX_FAILURE,
  THRESHOLDS_CREATE_REQUESTED,
  THRESHOLDS_CREATE_SUCCESS,
  THRESHOLDS_CREATE_FAILURE,
  THRESHOLDS_UPDATE_REQUESTED,
  THRESHOLDS_UPDATE_SUCCESS,
  THRESHOLDS_UPDATE_FAILURE,
  THRESHOLDS_DELETE_REQUESTED,
  THRESHOLDS_DELETE_SUCCESS,
  THRESHOLDS_DELETE_FAILURE,
  THRESHOLDS_BY_ITEM_REQUESTED,
  THRESHOLDS_BY_ITEM_SUCCESS,
  RESET_THRESHOLDS_STATE,
  UPLOAD_TOKEN_REQUESTED,
  UPLOAD_TOKEN_SUCCESS,
  THRESHOLDS_CSV_UPLOAD_REQUESTED,
  THRESHOLDS_CSV_UPLOAD_SUCCESS,
  THRESHOLDS_CSV_UPLOAD_FAILURE,
  THRESHOLDS_CSV_PROCESS_REQUESTED,
  THRESHOLDS_CSV_PROCESS_SUCCESS,
  THRESHOLDS_CSV_PROCESS_FAILURE,
  // THRESHOLD_CREATE_REQUESTED,
  // THRESHOLD_CREATE_SUCCESS,
  // THRESHOLD_CREATE_FAILURE,
} from '../types';


export const thresholdsIndexRequested = () => {
  return {
    type: THRESHOLDS_INDEX_REQUESTED
  }
};

export const thresholdsIndexSuccess = (thresholds, page) => {
  return {
    type: THRESHOLDS_INDEX_SUCCESS,
    payload: thresholds,
    page: page,
  }
};

export const thresholdsIndexFailure = () => {
  return {
    type: THRESHOLDS_INDEX_FAILURE
  }
};



export const thresholdsCreateRequested = () => {
  return {
    type: THRESHOLDS_CREATE_REQUESTED
  }
};

export const thresholdsCreateSuccess = (thresholdsResponse) => {
  return {
    type: THRESHOLDS_CREATE_SUCCESS,
    payload: thresholdsResponse
  }
};

export const thresholdsCreateFailure = () => {
  return {
    type: THRESHOLDS_CREATE_FAILURE
  }
};



export const thresholdsByItemRequested = (itemKey) => {
  return {
    type: THRESHOLDS_BY_ITEM_REQUESTED,
    itemKey: itemKey
  }
}


export const thresholdsByItemSuccess = (itemKey, response) => {
  return {
    type: THRESHOLDS_BY_ITEM_SUCCESS,
    itemKey: itemKey,
    response: response
  }
}

export const resetState = () => {
  return {
    type: RESET_THRESHOLDS_STATE,
  }
}

export const thresholdUpdateRequested = (thresholdId) => {
  return {
    type: THRESHOLDS_UPDATE_REQUESTED,
    thresholdId: thresholdId
  }
};

export const thresholdUpdateSuccess = (response, thresholdId) => {
  return {
    type: THRESHOLDS_UPDATE_SUCCESS,
    response: response.threshold,
    thresholdId: thresholdId
  }
};

export const thresholdUpdateFailure = (thresholdId) => {
  return {
    type: THRESHOLDS_UPDATE_FAILURE,
    thresholdId: thresholdId
  }
};


export const thresholdDeleteRequested = (thresholdId, productId, variationId) => {
  return {
    type: THRESHOLDS_DELETE_REQUESTED,
    thresholdId: thresholdId,
    productId: productId,
    variationId: variationId
  }
};

export const thresholdDeleteSuccess = (response, thresholdId) => {
  return {
    type: THRESHOLDS_DELETE_SUCCESS,
    response: response,
    thresholdId: thresholdId
  }
};

export const thresholdDeleteFailure = () => {
  return {
    type: THRESHOLDS_DELETE_FAILURE
  }
};

export const setUploadTokenRequested = () => {
  return {
    type: UPLOAD_TOKEN_REQUESTED
  }
};

export const setUploadTokenSuccess = (uploadLink) => {
  return {
    type: UPLOAD_TOKEN_SUCCESS,
    uploadLink: uploadLink
  }
};

export const setUploadRequested = () => {
  return {
    type: THRESHOLDS_CSV_UPLOAD_REQUESTED
  }
};

export const setUploadSuccess = () => {
  return {
    type: THRESHOLDS_CSV_UPLOAD_SUCCESS
  }
};

export const setUploadFailure = () => {
  return {
    type: THRESHOLDS_CSV_UPLOAD_FAILURE
  }
};
export const processCsvRequested = () => {
  return {
    type: THRESHOLDS_CSV_PROCESS_REQUESTED
  }
}

export const processCsvSucess = () => {
  return {
    type: THRESHOLDS_CSV_PROCESS_SUCCESS
  }
}

export const processCsvFailure = () => {
  return {
    type: THRESHOLDS_CSV_PROCESS_FAILURE
  }
}





export const thresholdsIndex = (signedPayload, continuationToken, page) => {
  return (dispatch) => {
    dispatch(thresholdsIndexRequested());

    let endPoint = Config.baseUrl + Config.thresholds;

    if (continuationToken) {
      endPoint = endPoint + `?continuationToken=${continuationToken}`;
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(thresholdsIndexSuccess(response.data, page));
      })
  }
}


export const thresholdsByItem = (signedPayload, productId, variationId) => {
  return (dispatch) => {
    dispatch(thresholdsByItemRequested(`${productId}/${variationId}`));

    let endPoint = Config.baseUrl + Config.threshold + `?product_id=${productId}`;

    if(variationId) {
      endPoint = endPoint + `&variation_id=${variationId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(thresholdsByItemSuccess(`${productId}/${variationId}`, response.data));
      })
  }
}


export const createThresholds = (signedPayload, thresholds, thresholdValues) => {
  return (dispatch) => {
    dispatch(thresholdsCreateRequested());

    let endPoint = Config.baseUrl + Config.thresholds;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { thresholds: thresholds, thresholdValues: thresholdValues }, { headers: headers })
      .then((response) => {
        dispatch(thresholdsCreateSuccess(response.data));
      })
  }
}


export const thresholdUpdate = (signedPayload, threshold, thresholdValues) => {
  return (dispatch) => {
    let thresholdId = `${threshold.product_id}/${threshold.variation_id || null}`;

    dispatch(thresholdUpdateRequested(thresholdId));

    let endPoint = Config.baseUrl + Config.threshold;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { threshold: threshold, thresholdValues: thresholdValues }, { headers: headers })
      .then((response) => {
        dispatch(thresholdUpdateSuccess(response.data, thresholdId));
      })
  }
}

export const thresholdDelete = (signedPayload, threshold) => {
  return (dispatch) => {
    let thresholdId = `${threshold.product_id}/${threshold.variation_id || null}`;
    dispatch(thresholdDeleteRequested(thresholdId, threshold.product_id, threshold.variation_id));

    let endPoint = Config.baseUrl + Config.threshold + `?product_id=${threshold.product_id}`;

    if(threshold.variation_id) {
      endPoint = endPoint + `&variation_id=${threshold.variation_id}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(thresholdDeleteSuccess(response, thresholdId));
      })
  }
}

export const uploadThresholds = (signedPayload, file) => {
  return (dispatch) => {
    dispatch(setUploadTokenRequested());

    let lastPeriodIndex = file.name.lastIndexOf(".");
    let extension = file.name.substring(lastPeriodIndex + 1);
    let fileNameWithoutExtension = file.name.substring(0, lastPeriodIndex);
    let cleanedFileName = fileNameWithoutExtension.replace(/ /g, '_').replace(/\./g, '_') + '.' + extension;

    let endPoint = Config.baseUrl + Config.thresholds + '/' + Config.upload + '/' + cleanedFileName;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(setUploadTokenSuccess(response.data));
        dispatch(uploadThresholdFile(signedPayload, file, response.data.action.upload_link, cleanedFileName));
      })

  }
}

export const uploadThresholdFile = (signedPayload, file, uploadLink, cleanedFileName) => {
  return (dispatch) => {
    dispatch(setUploadRequested());

    let type = mime.getType(file.name);

    var options = {
        headers: {
          'Content-Type': type
        }
      };

    Axios.put(uploadLink, file, options).then((response) => {
      dispatch(setUploadSuccess());
      dispatch(processCsv(signedPayload, cleanedFileName));
    })
    .catch((error) => {
      dispatch(setUploadFailure(error));
    })
    ;
  }
}

export const processCsv = (signedPayload, cleanedFileName) => {
  return (dispatch) => {
    dispatch(processCsvRequested());

    let endPoint = Config.baseUrl + Config.thresholds + '/' + Config.process + '/' + cleanedFileName;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(processCsvSucess());
      })
      .catch((error) => {
        dispatch(processCsvFailure(error));
      })
  }
}

export const reset = () => {
  return (dispatch)  =>{
    dispatch(resetState());
  }
}

